import { cn } from '@virginexperiencedays/tailwind';
import type { ButtonHTMLAttributes, ComponentType, HTMLAttributes } from 'react';
import type { IconProps } from '../../icons/types';
import { IconChevronRight } from '../../icons/IconChevronRight';

export const RegionList = ({ children, className, ...rest }: HTMLAttributes<HTMLUListElement>) => {
  return (
    <ul className={className} {...rest}>
      {children}
    </ul>
  );
};

export const RegionListItem = ({ children, className, ...rest }: HTMLAttributes<HTMLLIElement>) => {
  return (
    <li className={className} {...rest}>
      {children}
    </li>
  );
};

export const RegionListOption = ({
  className,
  isActive = false,
  children,
  Icon = IconChevronRight,
  ...rest
}: ButtonHTMLAttributes<HTMLButtonElement> & {
  isActive?: boolean;
  Icon?: ComponentType<IconProps>;
}) => (
  <button
    className={cn(
      'text-neutral-strong hover-only:hover:bg-background-primary-faded hover-only:hover:text-link flex w-full cursor-pointer items-center justify-between rounded p-2 font-normal leading-none',
      'dark:hover:bg-background-primary-faded-hover dark:hover:text-neutral',
      isActive &&
        'bg-background-primary-faded text-link dark:bg-background-primary-faded-hover dark:text-neutral',
      className
    )}
    {...rest}
  >
    <div className="flex text-left">{children}</div>
    {Icon && (
      <Icon className="text-neutral-strong h-5 min-h-5 w-5 min-w-5" width="20" height="20" />
    )}
  </button>
);
